import { FC } from "react";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Alert } from "@design-system/Alert/Alert";
import { Loader } from "@design-system/Loader/Loader";
import { ClientPricing } from "@hooks/billing/useClientPricing";
import { isOrganizationOwnedPricingBlocked } from "./planHelpers";

interface OrganizationOwnedPricingStatusProps {
    clientPricing: ClientPricing;
    isOrgOwned: boolean;
}

export const OrganizationOwnedPricingStatus: FC<
    OrganizationOwnedPricingStatusProps
> = ({ clientPricing, isOrgOwned }) => {
    if (!isOrganizationOwnedPricingBlocked({ clientPricing, isOrgOwned })) {
        return null;
    }

    if (clientPricing.isOrganizationOwnedPricingError) {
        return (
            <Alert variant="danger">
                Failed to load your firm&apos;s pricing. Try again in a moment.
            </Alert>
        );
    }

    return <Loader inline />;
};
